module.exports = "/assets/3fb8cd451948bbf3b815fda5885f403c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/W5.png
// module id = 1948
// module chunks = 0